module.exports = __webpack_public_path__ + "img/curva.45332735.svg";